import React from "react"
import { ButtonCta } from "packages/acquisition/components/chakra-components/CMS/ButtonCta"
import Image from "next/image"
import type { CMSPageProps } from "packages/acquisition/components/chakra-components/LandingPage/LandingPage.utils"
import type { BannerCTA, LivePromoTileContentBlock } from "types/cms"

import { imageContainer, contentContainer, ctaContainer } from "./Tile.css"
import { ContentBlock } from "./ContentBlock"

type Props = {
  src: string
  alt: string
  title: string
  contentBlocks: LivePromoTileContentBlock[]
  darkenImage?: boolean
  cta?: BannerCTA
  trackingModule?: CMSPageProps["trackingModule"]
}

export const Tile: React.FC<Props> = ({
  src,
  alt,
  title,
  contentBlocks,
  darkenImage,
  cta,
  trackingModule,
}) => (
  <div className={imageContainer}>
    <Image
      src={src}
      alt={alt}
      title={title}
      fill
      sizes="100vw"
      style={{
        objectFit: "cover",
        filter: darkenImage ? "brightness(0.9)" : undefined,
      }}
    />
    <div className={contentContainer}>
      {contentBlocks &&
        contentBlocks.length > 0 &&
        contentBlocks.map((contentBlock) => {
          const { id } = contentBlock
          return <ContentBlock key={id} {...contentBlock} />
        })}
      {cta && trackingModule && (
        <div className={ctaContainer}>
          <ButtonCta {...cta} trackingModule={trackingModule} />
        </div>
      )}
    </div>
  </div>
)
